const questions = [
    {
        id: 1,
        title: 'Who can open a Draft account?',
        description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
    },
    {
        id: 2,
        title: 'What if I withdraw money abroad?',
        description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
    },
    {
        id: 3,
        title: 'What happens when my subscription ends?',
        description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
    },
    {
        id: 4,
        title: 'Is this service better than YouBay?',
        description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
    },
    {
        id: 5,
        title: 'What happens if I withdraw more than $250?',
        description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Magni voluptate unde vero corporis tempora praesentium laboriosam ratione incidunt a odit.' 
    }
]

export default questions;